/* eslint-disable import/prefer-default-export */
export const UPDATE_SELECTED_PROPERTY = 'UPDATE_SELECTED_PROPERTY';
